import { ROUTES } from 'config';
import { Tabs } from 'melp-design/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

interface Props {
  surveyId: string;
}

export const SubmissionsTrainingTabsSwitcher: FC<Props> = ({ surveyId }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const history = useHistory();

  return (
    <Tabs
      value={pathname}
      onChange={(v) => history.push(v)}
      items={[
        {
          label: t('surveys.submissions.title'),
          value: ROUTES.surveys.training.submissions.list.replace(
            ':id',
            surveyId,
          ),
        },
        {
          label: t('status.pending'),
          value: ROUTES.surveys.training.submissions.pending.list.replace(
            ':id',
            surveyId,
          ),
        },
      ]}
    />
  );
};
